import {
  shape,
  string
} from 'prop-types'
import url from 'url-prop-type'

export default shape({
  label: string.isRequired,
  logo: url.isRequired
})